export default __webpack_public_path__ + "static/media/done.6dcd77f5.svg";